import { render, staticRenderFns } from "./EsteroDetail.vue?vue&type=template&id=58731d10&scoped=true&"
import script from "./EsteroDetail.vue?vue&type=script&lang=js&"
export * from "./EsteroDetail.vue?vue&type=script&lang=js&"
import style0 from "./EsteroDetail.vue?vue&type=style&index=0&id=58731d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58731d10",
  null
  
)

export default component.exports